(function() {

// Find all elements with a "parallax" class
    const parallaxElements = document.querySelectorAll('.media-effect--parallax, .media-effect--fixed-parallax');
    const parentElements = []
    parallaxElements.forEach(element => {
        const parent = element.closest('.shopify-section')
        if (parent) {
            parentElements.push(parent)
            element.classList.add('media-effect--active')
        }
    });

    function throttle(func, limit) {
        let throttled = false;
        return function () {
            if (!throttled) {
                func();
                throttled = true;
                setTimeout(() => {
                    throttled = false;
                }, limit);
            }
        };
    }

// Listen to the throttled scroll event and update --scroll variable dynamically
    const throttledScroll = throttle(() => {
        parentElements.forEach(element => {
            const scrollProgress = Math.max(0, Math.min(100, getScrollProgress(element)));
            element.style.setProperty('--scroll', scrollProgress);
        });
    }, 50); // Adjust the limit as needed

    window.addEventListener('scroll', throttledScroll);
    window.addEventListener('shopify:section:load', throttledScroll);
    window.addEventListener('DOMContentLoaded', throttledScroll);
    window.addEventListener('load', throttledScroll);


    // Helper function to calculate scroll progress for an element
    function getScrollProgress(element) {
      const elementTop = element.getBoundingClientRect().top;
      const elementHeight = element.clientHeight;
      const viewportHeight = window.innerHeight;

      // Calculate the scroll progress based on the element's position in the viewport
      return Math.max(0, Math.min(100, ((viewportHeight - elementTop) / (viewportHeight + elementHeight))));
    }

})()
